const CELL_TYPES = {
    NUMBER: "num",
    STRING: "str"
}
export default CELL_TYPES